import React, { useEffect } from 'react';
import { 
  Typography, 
  Container, 
  Paper, 
  Toolbar,
  Grid,
  TextField,
  Button,
  Box,
  useMediaQuery,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Modal

} from '@mui/material';

import styles from './Ledger.module.css';
import { styled } from '@mui/material/styles';
// import dayjs from 'dayjs';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import DetailsListController from '../components/ledger/DetailsListController';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#0B1420' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  // textAlign: 'center',
  // color: theme.palette.text.secondary,
  }));
const Ledger = ({
  ledgerData,
  summary,
  showModal,
  setDatePickerValue,
  // handleExchangeChange,
  handleSubmit,
  handleDownload,
}) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  useEffect(()=>{
    window.scrollTo(0, 0)
  },[])
  
  return (
    <Container 
    
      className={styles.ledgercontainer} sx={{background : isSmallScreen ? "#241E41" : "#241E41" , minHeight : "100vh"}}>
      {/* <Typography paddingTop={3} marginLeft={ isSmallScreen ? 3 : 0} component="h1" variant="h5" >
        Ledger Summary
      </Typography> */}
      {/* start, text added - srini - 30-01-25 */}
      {/* <Box >
        <Typography sx={{ fontSize: isSmallScreen ? '10px' : '12px', marginLeft: isSmallScreen ? '25px' : '05px', marginTop:'5px', letterSpacing: '0.2px', color: '#F3D45E' }}>*The balance displayed corresponds to the current financial year.</Typography>
      </Box> */}
      {/* end - srini - 30-01-25 */}
      {
        isSmallScreen ? 
          <Container >
            {/* <Grid container spacing={3} >
              <Grid item xs={12}>
                <Item className={styles.item} >
                <Table className={styles.table1}>
                  <TableBody>
                    {summary && summary.DATA && summary.DATA.map((row, index) => {
                        const isAmountPresent = !!row[3]; 
                        const amount = isAmountPresent ? row[3] : "0.00"; 
                        const title = (index == 0 && "Cash") || (index == 1 && "FnO") || row[2]; // Assuming "TITAL" key is at index 2
                           return <TableRow key={index}>
                              <TableCell className={styles.tableCellSmallScreen}>{title}</TableCell>
                              <TableCell className={styles.tableCellSmallScreen}>: {amount}</TableCell>
                            </TableRow>
                      })}
                    </TableBody>
                  </Table>
                </Item>
              </Grid>
            </Grid> */}
            <Toolbar className={styles.toolbar}>
              <Typography margin = "30px 0px 0px 10px" component="h1" variant="h5">
              Ledger Details
              </Typography> 
            </Toolbar>
          </Container>
         :
         <Box className={styles.ledgerData}>
          {/* <Grid container className={styles.grid}>
          <Grid item xs={6} >
          <Table className={styles.table}>
              <TableBody>
              {summary && summary.DATA && summary.DATA.slice(0, 6).map((row, index) => {
                const isAmountPresent = !!row[3]; 
                const amount = isAmountPresent ? row[3] : "0.00"; 
                const title = (index == 0 && "Cash") || (index == 1 && "FnO") || row[2]; // Assuming "TITAL" key is at index 2
                return (
                  <TableRow key={index}>
                    <TableCell className={styles.tableCell}>{title}</TableCell>
                    <TableCell className={styles.tableCell1}>: {amount}</TableCell>
                  </TableRow>
                    );
                  })}
                  </TableBody>
              </Table>
            </Grid>
          <Grid item xs={6} >
          <Table className={styles.table}>
              <TableBody>
                {summary && summary.DATA && summary.DATA.slice(6).map((row, index) => {
                  const isAmountPresent = !!row[3]; 
                  const amount = isAmountPresent ? row[3] : "0.00"; 
                  const title = row[2]; // Assuming "TITAL" key is at index 2
                  
                  return (
                    <TableRow key={index}>
                      <TableCell className={styles.tableCell}>{title}</TableCell>
                      <TableCell className={styles.tableCell1}>: {amount}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            </Grid>
          </Grid> */}
          <Typography marginTop={4} marginRight={2} marginBottom={1} component="h1" variant="h6" >
            Ledger Details
          </Typography>
        </Box>
      }
      <DetailsListController/>
     
    </Container>
  );
};

export default Ledger;
